import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { $api } from '../../../../helpers/api'
import axios from 'axios'

export const getLogin = createAsyncThunk('login', async ({ username, password }) => {
  try {
    const result = await $api.post('/users/login', { username, password })
    localStorage.setItem('accessToken', result?.data?.accessToken)
    return result?.data
  } catch (e) {
    if (axios.isAxiosError(e)) {
      return console.error(e.message)
    }
  }
})

export const getUser = createAsyncThunk('get user data', async validToken => {
  try {
    const result = await $api.get(`/users/validToken`)
    return result?.data
  } catch (e) {
    if (axios.isAxiosError(e)) {
      return console.error(e.message)
    }
  }
})

const initialState = {
  data: null,
  isLoading: false,
  error: null,
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getUser.pending, state => {
        state.isLoading = true
        state.data = null
        state.error = null
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.isLoading = false
        state.data = action.payload
      })
      .addCase(getUser.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload
      })

    builder
      .addCase(getLogin.pending, state => {
        state.isLoading = true
        state.data = undefined
        state.error = null
      })
      .addCase(getLogin.fulfilled, (state, action) => {
        state.isLoading = false
        state.data = action.payload
      })
      .addCase(getLogin.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload
      })
  },
})

export const { actions: userActions } = userSlice
export const { reducer: userReducer } = userSlice
